var _path, _path2, _path3, _path4, _g, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVideoScreenCapture(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    width: 200,
    height: 364,
    viewBox: "0 0 200 364",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#010101",
    d: "M105.518 188.228v164.973l-2.997.845-3.007-.845-57.633-16.426 30.011-150.807 5.854 1.091-29.008 145.7 50.776 14.469.05.02v-159.02z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#303337",
    d: "M163.152 336.775l-57.634 16.426-2.997.845-3.007-.845V188.228h5.965v159.02l.039-.02 50.767-14.469-28.998-145.7 5.852-1.091z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#943E20",
    d: "M52.461 182.784h106.121v7.456H52.461z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#642F20",
    d: "M66.578 190.24h72.526v7.437H66.578z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M113.73 359.518H91.813c-3.114-.658-6.316-.363-9.48-.53-10.914-.639-21.788-1.61-32.564-3.576-6.346-1.159-12.673-2.515-18.547-5.384-2.004-.972-3.732-2.26-4.813-4.282v-1.563c1.032-1.905 2.652-3.162 4.548-4.136 4.008-2.082 8.321-3.281 12.692-4.263 14.843-3.321 29.932-4.548 45.07-5.068 1.052-.03 2.093.116 3.095-.306h21.917c3.133.68 6.326.365 9.479.55 10.914.629 21.809 1.593 32.564 3.556 6.365 1.16 12.684 2.517 18.547 5.384 2.004.973 3.732 2.26 4.822 4.283v1.563c-1.031 1.915-2.65 3.164-4.537 4.155-4.018 2.072-8.34 3.262-12.713 4.253-14.783 3.312-29.813 4.529-44.912 5.059-1.088.039-2.21-.128-3.251.305z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M91.814 330.41c-1.002.422-2.043.275-3.095.306-15.138.521-30.227 1.747-45.07 5.068-4.371.981-8.684 2.181-12.692 4.263-1.896.974-3.517 2.23-4.548 4.136 0-4.224.03-8.448-.03-12.681-.009-.935.187-1.121 1.12-1.121 21.436.029 42.89.029 64.315.029zm87.329 13.773c-1.09-2.023-2.818-3.311-4.822-4.283-5.863-2.867-12.182-4.224-18.547-5.384-10.756-1.963-21.65-2.927-32.564-3.556-3.152-.185-6.346.13-9.479-.55 21.344 0 42.691.021 64.027-.039 1.229 0 1.426.345 1.416 1.474-.07 4.116-.031 8.222-.031 12.338zm-152.734 1.562c1.081 2.022 2.81 3.311 4.813 4.282 5.874 2.869 12.201 4.225 18.547 5.384 10.776 1.966 21.65 2.938 32.564 3.576 3.164.167 6.366-.128 9.48.53-21.386 0-42.762 0-64.157.039-1.07 0-1.296-.217-1.286-1.286.088-4.175.039-8.34.039-12.525zm87.321 13.773c1.041-.433 2.162-.266 3.25-.306 15.1-.529 30.129-1.747 44.912-5.059 4.373-.991 8.695-2.181 12.713-4.253 1.887-.991 3.506-2.24 4.537-4.155 0 4.225-.039 8.458.031 12.683 0 .933-.197 1.119-1.131 1.119-21.433-.029-42.868-.029-64.312-.029z"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#68A142",
    d: "M90.684 79.275l-5.394 20.767s8.654-6.346 10.079-13.537c.758-3.811-1.719-6.463-4.685-7.23z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#88C540",
    d: "M85.291 100.042l5.394-20.767c-2.957-.766-6.414.335-7.604 4.028-2.25 6.995 2.21 16.739 2.21 16.739z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#68A142",
    d: "M80.821 65.503L75.428 86.27s8.644-6.347 10.078-13.536c.757-3.812-1.718-6.465-4.685-7.231z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#88C540",
    d: "M75.428 86.27l5.393-20.767c-2.967-.766-6.415.334-7.613 4.027-2.25 6.994 2.22 16.74 2.22 16.74z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#68A142",
    d: "M32.941 77.645l14.215 12.044s-1.699-9.156-6.798-12.986c-2.691-2.024-5.697-1.082-7.417.942z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#88C540",
    d: "M47.157 89.688L32.941 77.645c-1.719 2.034-2.151 5.147.295 7.476 4.618 4.39 13.921 4.567 13.921 4.567z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#68A142",
    d: "M46.4 75.65l14.214 12.044s-1.699-9.156-6.798-12.986c-2.691-2.034-5.697-1.092-7.416.942z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#88C540",
    d: "M60.615 87.694L46.4 75.65c-1.72 2.034-2.152 5.138.294 7.476 4.618 4.381 13.921 4.568 13.921 4.568z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#68A142",
    d: "M37.981 105.17l10.374-15.481s-8.9 2.73-12.142 8.213c-1.709 2.906-.442 5.794 1.768 7.268z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#88C540",
    d: "M48.355 89.688L37.981 105.17c2.21 1.483 5.354 1.572 7.397-1.12 3.841-5.088 2.977-14.362 2.977-14.362z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#68A142",
    d: "M54.612 102.911l10.374-15.482s-8.9 2.722-12.142 8.213c-1.71 2.907-.442 5.775 1.768 7.269z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#88C540",
    d: "M64.986 87.429l-10.374 15.482c2.21 1.473 5.354 1.551 7.397-1.14 3.841-5.069 2.977-14.342 2.977-14.342z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#68A142",
    d: "M23.453 96.604l23.203-6.936s-11.18-4.637-18.97-1.817c-4.126 1.503-5.226 5.443-4.233 8.753z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#88C540",
    d: "M46.656 89.669l-23.203 6.936c.982 3.32 4.076 5.992 8.34 4.99 8.064-1.916 14.863-11.926 14.863-11.926z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#68A142",
    d: "M132.955 76.21v25.463s8.035-9.862 7.533-18.557c-.263-4.606-3.9-6.906-7.533-6.906z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#88C540",
    d: "M132.955 101.673V76.21c-3.637 0-7.26 2.3-7.537 6.906-.5 8.695 7.537 18.557 7.537 18.557z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#68A142",
    d: "M109.24 79.433l11.758 22.574s2.564-12.456-1.895-19.932c-2.357-3.959-6.64-4.322-9.863-2.642z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#88C540",
    d: "M120.998 102.007L109.24 79.433c-3.223 1.68-5.383 5.393-3.496 9.607 3.576 7.938 15.254 12.967 15.254 12.967z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#68A142",
    d: "M69.966 56.505L66.165 76.24s7.702-6.454 8.615-13.263c.481-3.604-1.994-5.932-4.814-6.472z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#88C540",
    d: "M66.165 76.24l3.802-19.735c-2.819-.551-5.983.688-6.876 4.225-1.681 6.66 3.074 15.51 3.074 15.51z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#68A142",
    d: "M89.614 35.591l-8.704 23.92s10.924-6.523 13.418-14.862c1.326-4.412-1.306-7.81-4.714-9.058z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#88C540",
    d: "M80.91 59.511l8.704-23.92c-3.419-1.247-7.614-.324-9.441 3.909-3.448 7.997.737 20.011.737 20.011z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "#68A142",
    d: "M86.401 11.219L72.432 32.497s12.132-3.832 16.483-11.375c2.299-3.99.531-7.898-2.514-9.903z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "#88C540",
    d: "M72.432 32.497l13.969-21.278c-3.035-1.983-7.329-2.063-10.079 1.631-5.197 6.995-3.89 19.647-3.89 19.647z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "#68A142",
    d: "M105.9 71.731l-18.184 17.82s12.672-1.179 18.528-7.613c3.106-3.41 2.201-7.613-.344-10.207z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "#88C540",
    d: "M87.716 89.551l18.184-17.82c-2.545-2.594-6.729-3.586-10.197-.551-6.561 5.718-7.987 18.371-7.987 18.371z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "#68A142",
    d: "M118.365 60.267l-25.058 4.48s11.119 6.179 19.587 4.155c4.489-1.081 6.11-5.059 5.471-8.635z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "#88C540",
    d: "M93.307 64.747l25.058-4.48c-.639-3.575-3.545-6.748-8.123-6.198-8.644 1.032-16.935 10.678-16.935 10.678z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "#68A142",
    d: "M85.88 49.313l10.53 15.188s.717-9.204-3.172-14.185c-2.063-2.633-5.187-2.495-7.358-1.003z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "#88C540",
    d: "M96.41 64.501L85.88 49.313c-2.162 1.514-3.379 4.381-1.631 7.24 3.292 5.393 12.161 7.948 12.161 7.948z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "#68A142",
    d: "M70.949 110.583l24.135 8.094s-6.798-10.756-15.196-13.035c-4.45-1.218-7.781 1.492-8.939 4.941z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "#88C540",
    d: "M95.084 118.677l-24.135-8.094c-1.15 3.447-.128 7.613 4.155 9.342 8.074 3.231 19.98-1.248 19.98-1.248z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "#68A142",
    d: "M62.118 100.14l25.441.492s-9.694-8.223-18.398-7.898c-4.607.177-6.974 3.772-7.043 7.406z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "#88C540",
    d: "M87.559 100.632l-25.441-.492c-.079 3.637 2.151 7.31 6.749 7.662 8.683.669 18.692-7.17 18.692-7.17z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "#68A142",
    d: "M107.904 90.238L91.5 109.698s12.495-2.367 17.709-9.332c2.771-3.693 1.467-7.79-1.305-10.128z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "#88C540",
    d: "M91.5 109.698l16.405-19.46c-2.781-2.338-7.043-2.927-10.217.423-5.983 6.317-6.188 19.037-6.188 19.037z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "#68A142",
    d: "M99.426 99.502l19.334 16.571s-2.27-12.523-9.186-17.799c-3.674-2.79-7.779-1.533-10.148 1.228z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "#88C540",
    d: "M118.76 116.073L99.426 99.502c-2.367 2.761-2.984 7.015.334 10.207 6.277 6.04 19 6.364 19 6.364z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "#68A142",
    d: "M130.057 52.31l-25.012-4.725s8.203 9.726 16.828 10.846c4.576.59 7.506-2.555 8.184-6.121z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fill: "#88C540",
    d: "M105.045 47.585l25.012 4.725c.668-3.564-.916-7.563-5.385-8.674-8.447-2.112-19.627 3.949-19.627 3.949z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fill: "#68A142",
    d: "M142.531 120.731l-10.629-18.725s-1.787 10.609 2.211 16.798c2.123 3.272 5.746 3.449 8.418 1.927z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fill: "#88C540",
    d: "M131.902 102.007l10.629 18.725c2.672-1.514 4.391-4.727 2.662-8.224-3.261-6.601-13.291-10.501-13.291-10.501z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fill: "#68A142",
    d: "M41.704 72.253l25.384 1.953s-9.214-8.762-17.918-8.938c-4.617-.08-7.181 3.358-7.466 6.985z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fill: "#88C540",
    d: "M67.088 74.206l-25.384-1.953c-.274 3.624 1.729 7.416 6.297 8.044 8.635 1.159 19.087-6.091 19.087-6.091z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fill: "#E48F25",
    d: "M113.385 134.837l11.062-55.109 2.377.47-5.658 28.213 14.803-11.002 1.445 1.955-16.965 12.604-4.687 23.341zm-69.49-44.068c.01.02.02.049.039.079.059.098.128.177.216.255.02.021.04.049.068.069.089.068.187.128.286.167.029.02.059.02.098.039.108.029.216.06.334.06h.04c.059 0 .118 0 .177-.011l29.49-4.439a5016.104 5016.104 0 0015.669 19.105c5.482 21.917 8.093 32.378 8.203 32.899v.01l2.387-.491c-.129-.649-7.917-31.789-14.43-57.801l25.237-42.359v-.009l-2.094-1.247v.01L85.625 77.37c-6.572-26.248-12.839-51.239-13.291-53.066l-.01-.01-2.357.6c.274 1.109 10.796 43.065 18.969 75.698C76.086 84.974 60.791 66.2 59.937 64.658l-2.132 1.179.009.01c.55 1.002 5.62 7.378 15.04 18.949l-28.065 4.225c-.01 0-.02.01-.04.02-.127.02-.245.059-.354.117a.978.978 0 01-.079.051 1.089 1.089 0 00-.295.264l-.029.03a1.193 1.193 0 00-.226.903c0 .01.019.029.019.049.022.108.061.216.11.314zm1.07.669h.04-.04zm-.422-.08zm-.353-.215z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fill: "#68A142",
    d: "M64.435 4.858l7.85 24.22s4.607-11.867 1.444-19.981c-1.67-4.293-5.835-5.358-9.294-4.239z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fill: "#88C540",
    d: "M72.285 29.078l-7.85-24.22c-3.447 1.115-6.198 4.416-5.039 8.885 2.201 8.42 12.889 15.335 12.889 15.335z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fill: "#68A142",
    d: "M53.345 31.927l22.996 10.904S70.87 31.347 62.804 28.076c-4.272-1.729-7.907.57-9.459 3.851z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fill: "#88C540",
    d: "M76.341 42.831L53.345 31.927c-1.562 3.281-1.041 7.555 3.006 9.765 7.642 4.184 19.99 1.139 19.99 1.139z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fill: "#68A142",
    d: "M92.088 27.674l10.541 23.173s3.232-12.299-.824-20c-2.153-4.087-6.407-4.676-9.717-3.173z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fill: "#88C540",
    d: "M102.629 50.847L92.088 27.674c-3.311 1.502-5.658 5.098-3.998 9.4 3.144 8.114 14.539 13.773 14.539 13.773z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fill: "#68A142",
    d: "M122.943 25.698l-14.41 14.373s10.117-1.023 14.756-6.219c2.455-2.75 1.707-6.101-.346-8.154z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fill: "#88C540",
    d: "M108.533 40.071l14.41-14.373c-2.053-2.063-5.402-2.809-8.162-.373-5.197 4.627-6.248 14.746-6.248 14.746z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fill: "#68A142",
    d: "M48.973 48.98l14.284 21.061s1.12-12.671-4.175-19.587c-2.81-3.654-7.103-3.517-10.109-1.474z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fill: "#88C540",
    d: "M63.257 70.041L48.973 48.98c-3.005 2.032-4.725 5.972-2.357 9.941 4.46 7.467 16.641 11.12 16.641 11.12z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fill: "#68A142",
    d: "M130.686 60.827l-6.121 24.716s10.168-7.643 11.77-16.198c.843-4.53-2.124-7.633-5.649-8.518z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fill: "#88C540",
    d: "M124.564 85.543l6.121-24.716c-3.527-.864-7.613.492-8.98 4.893-2.572 8.32 2.859 19.823 2.859 19.823z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fill: "#68A142",
    d: "M154.703 86.505l-21.268 13.989s12.652 1.296 19.637-3.89c3.703-2.761 3.625-7.053 1.631-10.099z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fill: "#88C540",
    d: "M133.436 100.494l21.268-13.989c-1.994-3.024-5.914-4.803-9.912-2.494-7.536 4.351-11.356 16.483-11.356 16.483z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fill: "#F58536",
    d: "M78.395 126.035l8.094 56.239h23.273c.01-.59.02-1.199.059-1.818 2.014-39.451-26.297-49.154-28.321-49.154l-1.326-5.267h-1.779z"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fill: "#EF6A49",
    d: "M80.173 126.035l1.326 5.267c2.024 0 30.335 9.703 28.321 49.154-.039.619-.049 1.229-.059 1.818h10.166l8.096-56.239h-47.85z"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fill: "#842019",
    d: "M106.293 131.399h21.592a3.625 3.625 0 003.615-3.616c0-2.003-1.631-3.634-3.615-3.634h-21.592a3.63 3.63 0 013.625 3.634 3.62 3.62 0 01-3.625 3.616z"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fill: "#A72922",
    d: "M74.907 127.783a3.627 3.627 0 003.625 3.616h27.761a3.62 3.62 0 003.625-3.616 3.63 3.63 0 00-3.625-3.634H78.532a3.638 3.638 0 00-3.625 3.634zm10.599 52.673h35.404v2.84H85.506z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoScreenCapture);
export default __webpack_public_path__ + "static/media/video-screen-capture.6f893224408d873b5d1da8f8f5e264ac.svg";
export { ForwardRef as ReactComponent };